<template>
    <b-container>
        <h1>Add Risk Type</h1>
        <form v-on:submit.prevent="saveForm">
            <!-- Name Field -->
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" class="form-control" id="name" v-model="name">
                <div class="text-danger validation-message" v-if="validation.hasError('name')">
                    The name of the Risk Type is required
                </div>
            </div>

            <!-- Status Field -->
            <div class="form-group">
                <label for="set_active">Status</label>
                <select class="form-control" id="set_active" v-model="set_active">
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                </select>
            </div>

            <!-- Aspects Checkboxes -->
            <div class="form-group">
                <label>Aspects</label>
                <div v-for="type in types" :key="type.id">
                    <b-form-checkbox v-model="aspects" :value="type.id">
                        {{ type.name }}
                    </b-form-checkbox>
                </div>
            </div>

            <!-- Submit Button -->
            <button type="submit" class="btn btn-primary" :disabled="isLoading">
                Save and Update
            </button>
        </form>
    </b-container>
</template>
<script>
import PolicyTypeDataService from '@/services/PolicyTypeDataService';
import AspectDataService from '@/services/AspectDataService';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

export default {
    name: "risktypeEdit",
    data() {
        return {
            name: "",
            aspects: [],
            types: [],
            set_active: 1,
            isLoading: false,
        };
    },
    mixins: [SimpleVueValidation.mixin], // Attach the validation plugin
    validators: {
        'name': function (value) {
            return Validator.value(value).required('The name is required');
        },
    },
    created() {
        
        // Fetch Aspect Types
        AspectDataService.forms()
            .then((res) => {
                this.types = res.data;
            })
            .catch((error) => {
                console.error('Failed to load aspects:', error);
            });
    },
    methods: {
        saveForm() {
            this.$validate().then((success) => {
                if (!success) return;

                this.isLoading = true;

                PolicyTypeDataService.create({
                    name: this.name,
                    aspects: JSON.stringify(this.aspects), // Save aspects as a JSON string
                    set_active: this.set_active,
                })
                    .then(() => {
                        this.$router.push('/admin/risktypes?created=success');
                    })
                    .catch((error) => {
                        console.error('Failed to save risk type:', error);
                        alert('Failed to save data. Please try again.');
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },
    },
};
</script>


<style>
.validation-message {
    margin-top: -8px;
    margin-bottom: 10px;
}
.doceditor .ck-editor__editable {
    min-height: 73vh !important;
}
</style>
